import { logger } from "./logging";

const log = logger.getChild("recaptcha");

export interface Grecaptcha {
    execute: (siteKey: string, { action }: { action: string }) => Promise<string>;
    ready: (cb: () => void) => void;
    reset: () => void;
}

declare global {
    interface Window {
        grecaptcha?: Grecaptcha;
    }
}

/**
 * @param siteKey Must be added on script load if invoking programmatically (.execute())
 */
export const getReCaptchaLib = (siteKey?: string): Promise<Grecaptcha> => {
    if (typeof window === "undefined") {
        return Promise.reject();
    }

    if (typeof window.grecaptcha === "undefined") {
        return new Promise((resolve, reject) => {
            log.debug(`Injecting script. siteKey: "${siteKey}"`);

            const script = document.createElement("script");
            script.src = `https://www.google.com/recaptcha/api.js${siteKey ? `?render=${siteKey}` : ""}`;
            script.type = "text/javascript";
            script.defer = true;
            script.async = true;
            script.onload = () => {
                if (window.grecaptcha) {
                    resolve(window.grecaptcha);
                } else {
                    reject(new Error("Error loading reCAPTCHA"));
                }
            };
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    log.debug(`Script has already loaded. siteKey: "${siteKey}"`);

    return Promise.resolve(window.grecaptcha);
};
